import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-search-icon',
    templateUrl: './search-icon.component.html',
    styleUrls: ['./search-icon.component.scss']
})
export class SearchIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 24;
    }
}
